// extracted by mini-css-extract-plugin
export default {"container":"g97STQ","box":"uY7__O","title":"zzHlkr","subtitle":"AYqc3a","button":"vvIsi0"};